import { Component, inject } from '@angular/core';
import { ProtectedAreaOtherUseDetailService } from '../proxy/geographic/controllers';
import { ProtectedAreaOtherUseDetailProjectionPlanningOrchestratorService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ProtectedAreaOtherUseDetailCreateDto,
  ProtectedAreaOtherUseDetailUpdateDto,
} from '../proxy/geographic/dtos/protected-area-other-use-detail';
import {
  GetProtectedAreaOtherUseDetailProjectionListInputDto,
  ProtectedAreaOtherUseDetailProjectionDto,
  ProtectedAreaOtherUseDetailProjectionExcelDownloadDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/protected-area-other-use-details/models';
import { PROTECTEDAREAOTHERUSEDETAIL_CONFIG, PROTECTEDAREAOTHERUSEDETAIL_FIELDS } from './protected-area-other-use-detail.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ICrudService } from '@zendra/shared';

@Component({
  selector: 'app-protected-area-other-use-detail',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ProtectedAreaOtherUseDetailService, ConfirmationService],
  templateUrl: './protected-area-other-use-detail.html',
  styleUrl: './protected-area-other-use-detail.scss',
})
export class ProtectedAreaOtherUseDetail extends BaseHierarchicalCrudComponent<
  ProtectedAreaOtherUseDetailProjectionDto,
  ProtectedAreaOtherUseDetailCreateDto,
  ProtectedAreaOtherUseDetailUpdateDto,
  ProtectedAreaOtherUseDetailProjectionExcelDownloadDto
> {
  private readonly geographicService = inject(ProtectedAreaOtherUseDetailService);
  private readonly orchestratorService = inject(
    ProtectedAreaOtherUseDetailProjectionPlanningOrchestratorService,
  );

  service: ICrudService<
    ProtectedAreaOtherUseDetailProjectionDto,
    ProtectedAreaOtherUseDetailCreateDto,
    ProtectedAreaOtherUseDetailUpdateDto,
    ProtectedAreaOtherUseDetailProjectionExcelDownloadDto
  > = {
    create: input => this.geographicService.create(input),
    update: (id, input) => this.geographicService.update(id, input),
    deleteByIds: ids => this.geographicService.deleteByIds(ids),
    projectionConsistency: this.createProjectionConsistency(
      this.orchestratorService,
      'protectedAreaOtherUseDetailId',
    ),
    getList: (query: GetProtectedAreaOtherUseDetailProjectionListInputDto) =>
      this.orchestratorService.getList(query),
    getDownloadToken: () => this.orchestratorService.getDownloadToken(),
    getListAsExcelFile: input => this.orchestratorService.getListAsExcelFile(input),
  };
  config = PROTECTEDAREAOTHERUSEDETAIL_CONFIG;
  fields = PROTECTEDAREAOTHERUSEDETAIL_FIELDS;

  protected prepareUpdateDto(data: any, selected: ProtectedAreaOtherUseDetailProjectionDto): ProtectedAreaOtherUseDetailUpdateDto {
    return {
      protectedAreaId: data.protectedAreaId,
      otherUseId: data.otherUseId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ProtectedAreaOtherUseDetail';
  }
}
